export function getContentClasses(type) {
  return {
    success: 'text-green-700 dark:text-green-100',
    info: 'text-blue-700 dark:text-blue-100',
    error: 'text-red-700 dark:text-red-100',
    warning: 'text-yellow-700 dark:text-yellow-100',
  }[type]
}
